import { featureFlags } from "$global-providers/feature-flags-provider/feature-flags";
import { useFeatureFlag } from "$global-providers/feature-flags-provider/provider";
import { useEffect } from "react";
import { useAgentVoiceInput } from "./use-agent-voice-input";
import type { VoiceInput } from "./voice-input";

export const useVoiceInput = (): VoiceInput => {
  const [voiceEnabled] = useFeatureFlag(
    featureFlags.epocus.hackathonVoiceControl,
  );
  // Runs unconditionally — hooks cannot be called by branch — but touches the microphone only
  // from its own start(), so with the flag off it stays inert.
  const voice = useAgentVoiceInput();

  // Turning the flag off is a kill switch, not a hide: LaunchDarkly pushes the change live, and
  // that is exactly when someone reaches for it. Without this the microphone stays open and an
  // upload already in flight still delivers, after voice has been switched off.
  const { cancel } = voice;
  useEffect(() => {
    if (voiceEnabled) return;
    cancel();
  }, [voiceEnabled, cancel]);

  // Gated here rather than only on `available`, so that with the flag off the composer is exactly
  // what it was before voice existed.
  return { ...voice, available: voiceEnabled && voice.available };
};
